import React, { useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { Box, Stack } from '@mui/material';
import { DateTime } from 'luxon';
import DashboardHeader from './header';
import WhatappChart from './whatsapp';
import TwilloChart from './twillo';
import AIChart from './ai';
import NegotiatorChart from './negotiator';
import TotalTokenCusume from './totalTokenCusume';
import { useAnalyticToken } from '@api';

const Analytics: React.FC<RouteComponentProps> = () => {
  const [start, setStart] = useState<DateTime | null>(null);
  const [end, setEnd] = useState<DateTime | null>(null);
  const [billingAccount, setBillingAccount] = useState<BillingAccount>();

  const {
    data: analticsToken,
  } = useAnalyticToken({
    startDate: start?.toISO({
      suppressMilliseconds: true,
      includeOffset: false
    }),
    endDate: end?.toISO({
      suppressMilliseconds: true,
      includeOffset: false
    }),
    billingAccountId: billingAccount?.id
  });

  return (
    <Stack sx={{ m: 2 }}>
      <Box sx={{ mt: 1, mb: 2 }}>
        <DashboardHeader
          onSelectRange={(start, end) => {
            setStart(start);
            setEnd(end);
          }}
          onSelectedAccount={function (billingAccount?: BillingAccount): void {
            setBillingAccount(billingAccount);
          }}
        />
        <TotalTokenCusume
          analyticsToken={analticsToken?.data?.data}
          start={start}
          end={end}
          billingAccount={billingAccount}
        />
      </Box>

      <NegotiatorChart billingAccount={billingAccount} dates={{ start, end }} />

      <AIChart
        billingAccount={billingAccount}
        dates={{ start, end }}
        aiResponseCount={analticsToken?.data?.data?.aiResponseCount || 0}
        aiSentimentCount={analticsToken?.data?.data?.aiSentimentCount || 0}
        aiEnquiresCount={analticsToken?.data?.data?.aiEnquiresCount || 0}
      />

      <WhatappChart
        billingAccount={billingAccount}
        OutboundCount={analticsToken?.data?.data?.outboundCount || 0}
        InboundCount={analticsToken?.data?.data?.inboundCount || 0}
        TemplateCount={analticsToken?.data?.data?.templateCount || 0}
        dates={{ start, end }}
      />
      <TwilloChart
        billingAccount={billingAccount}
        TwillioInboundCallCount={analticsToken?.data?.data?.twillioInboundCallCount || 0}
        TwillioOutboundCallCount={analticsToken?.data?.data?.twillioOutboundCallCount || 0}
        TwillioOutboundSmsCount={analticsToken?.data?.data?.twillioOutboundSmsCount || 0}
        TwillioInboundSmsCount={analticsToken?.data?.data?.twillioInboundSmsCount || 0}
        TwillioOtherCount={analticsToken?.data?.data?.twillioOtherCount || 0}
        dates={{ start, end }}
      />
    </Stack>
  );
};
export default Analytics;
